@if (loaderIcon | async) {
  <app-loader></app-loader>
}

<div class="rowCls content_out">
  <form [formGroup]="taxGroupForm">
    <div class="row">
      <div class="col-lg-4 common_form MerchandiseForm">
        <div class="row mx-0 mt-3" [hidden]="fromPage == 'StoreInfoTax'">
          <div class="general_form_lst">
            <label>Tax Group Id</label>
            <div class="inputbox">
              <input type="text" class="form-control" formControlName="Id" readonly>
            </div>
          </div>
        </div>
        <div class="row mx-0 mt-3">
          <div class="general_form_lst">
            <label>Name <span class="required">*</span></label>
            <div class="inputbox">
              <input type="text" formControlName="TaxGroupName" maxlength="30" class="form-control" (keyup)="isTaxGroupNameExists($event.target.value)">

              @if (taxGroupForm.get('TaxGroupName').errors  &&
                (taxGroupForm.get('TaxGroupName').dirty || taxGroupForm.get('TaxGroupName').touched) &&
                taxGroupForm.get('TaxGroupName').validator !== null) {
                <div class="alert alert-danger"
                  >
                  @if (taxGroupForm.get('TaxGroupName').errors.required) {
                    <span>
                    Name is required</span>
                  }
                  @if (taxGroupForm.get('TaxGroupName').errors.whitespace) {
                    <span
                    i18n="@@Invalid_input"> Invalid input </span>
                  }
                </div>
              }
              @if (isTaxGroupNameExist) {
                <div class="alert alert-danger">
                  @if (isTaxGroupNameExist) {
                    <span>
                    Tax Group {{taxGroupForm.get('TaxGroupName').value}} already exists!</span>
                  }
                </div>
              }

            </div>
          </div>
        </div>
        <div class="row mx-0 mt-3">
          <div class="general_form_lst">
            <label>Tax Option <span class="required">*</span></label>
            <div class="inputbox">
              <select id="TaxOptions" class="form-select" formControlName="TaxOption" (change)="onTaxOptionChange($event.target.value, 'DropDown')" required>
                @for (item of taxOptionsList; track item) {
                  <option [value]="item.Id">{{item.Name}}</option>
                }
              </select>
              @if (taxGroupForm.get('TaxOption').errors  &&
                (taxGroupForm.get('TaxOption').dirty || taxGroupForm.get('TaxOption').touched) &&
                taxGroupForm.get('TaxOption').validator !== null) {
                <div class="alert alert-danger"
                  >
                  @if (taxGroupForm.get('TaxOption').errors.required) {
                    <span>
                    Tax Option is required</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row mx-0 mt-3">
          <div class="general_form_lst">
            <label>Total Percentage</label>
            <div class="inputbox">
              <input type="text" class="form-control w-50" formControlName="TotalPercentage" readonly>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 NoSidePadding">
        <div class="row mx-0 mt-3 common_form">
          <div class="selectbox">
            <label>Option</label>
            <div class="inputbox">
              <ejs-dropdownlist id='taxgroupsetting' #taxgroupsetting [value]="1"
                (change)="showSelectedOption($event)" [dataSource]='settingsDropdownData'
                [fields]='fields' [placeholder]='waterMark' (open)="addimageForFirst($event)">
                <ng-template #itemTemplate let-data>
                  <div class="status_checked">
                    <span>{{data.Name}} </span>
                    <img class="valueTemp" src="../../../../assets/images/checked.svg" alt="employee" style="display:none" />
                  </div>
                </ng-template>
                <!-- <ng-template #valueTemplate let-data>
                <div>
                  <div class="name p-1" style="font: 12px;"> {{data.Name}} </div>
                </div>
              </ng-template> -->
            </ejs-dropdownlist>
          </div>
        </div>
      </div>
      <div id="containerTable" class="mt-3 common_section" style="min-height:445px;">
        @switch (selectedOpt) {
          @case (1) {
            <div class="row mx-0 common_section">
              <div class="select_rgt_bottom_list NoSidePadding">
                <label></label>
                <div class="inputbox">
                  @if (allTaxList) {
                    <div id="containerTable" class="common_section" style="min-height:460px;">
                      @if (dataLoaded | async) {
                        <app-select-template (isFormDirty)="setDirtyFlag($event)"
                          [SelectionName]="TaxSelection"
                          [ActiveFormArray]="taxGroupForm.controls.SeletedTaxList" [AllData]="allTaxList" [ModuleName]="moduleName">
                        </app-select-template>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @case (2) {
            <div class="row mx-0 common_section">
              <div class="select_rgt_bottom_list NoSidePadding">
                <label></label>
                <div class="inputbox">
                  <div id="containerTable" class="common_section" style="min-height:460px;">
                    @if (dataLoaded | async) {
                      <app-select-template (isFormDirty)="setDirtyFlag($event)"
                        [SelectionName]="StoreSelection"
                        [ActiveFormArray]="taxGroupForm.controls.StorageFacilities" [AllData]="availableLocations">
                      </app-select-template>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</form>

</div>
<div class="bottom_button">
  @if (taxGroupId > 0) {
    <button class="btn btn-primary me-2"
      permissionHandler [functId]="30" [elementType]="eNumElementTypes.BUTTON"
      [action]="eNumActionTypes.DELETE"
    (click)="deleteTaxGrouoPopUp.show()">Delete</button>
  }
  <button type="button" class="btn btn-outline-primary me-3" (click)="openCancelConformation()">Cancel</button>
  <button type="submit" class="btn btn-primary"
    permissionHandler [functId]="30" [elementType]="eNumElementTypes.BUTTON"
    [action]="eNumActionTypes.EDIT"
  [disabled]="isTaxGroupNameExist || taxGroupForm.invalid" (click)="saveConformaionPop()">Save</button>
</div>





<div class="modal fade" bsModal #conformationPopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
        <button type="button" class="close pull-right" (click)="conformationPopUp.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="p-4">
        {{ taxGroupId > 0 ? 'Save' :  'Create New' }} Tax Group?
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary me-3" (click)="conformationPopUp.hide()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="saveTaxGroup()">Save</button>
      </div>


    </div>
  </div>
</div>

<div class="modal fade" bsModal #reactivePopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <!-- <div class="modal-header">
      <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
      <button type="button" class="close pull-right" (click)="reactivePopUp.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->

    <div class="p-4">
      Tax Group  {{taxGroupForm.get('TaxGroupName').value}} already exists but has been deleted. Reactivate it?
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-primary me-3" (click)="reactivePopUp.hide()">No</button>
      <button class="btn btn-primary" type="button" (click)="saveTaxGroup()">Yes</button>
    </div>

  </div>
</div>
</div>



<div class="modal fade" bsModal #cancelConformationPopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <!-- <div class="modal-header">
      <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
      <button type="button" class="close pull-right" (click)="cancelConformationPopUp.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->

    <div class="p-4">
      Are you sure you want to cancel? Any data modifications will not be saved
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-primary me-3" (click)="cancelConformationPopUp.hide()">No</button>
      <button class="btn btn-primary" type="button" (click)="back()">Yes</button>
    </div>


  </div>
</div>
</div>


<div class="modal fade" bsModal #taxValidationPopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <!-- <div class="modal-header">
      <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
      <button type="button" class="close pull-right" (click)="taxValidationPopUp.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->

    <div class="p-4">
      At least 2 Taxes need to be selected for the Tax Group
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="taxValidationPopUp.hide()">Ok</button>
    </div>


  </div>
</div>
</div>



<div class="modal fade" bsModal #invalidTaxPopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <!-- <div class="modal-header">
      <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
      <button type="button" class="close pull-right" (click)="taxValidationPopUp.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->

    <div class="p-4">
      Tax {{invalidTaxName}} is already applicable for the Facility {{ getStoreName(invalidFacilityId) }} selected and cannot be applied as part of this Tax Group.
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="invalidTaxPopUp.hide()">Ok</button>
    </div>


  </div>
</div>
</div>



<div class="modal fade" bsModal #deleteTaxGrouoPopUp="bs-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <div class="p-4">
        Delete Tax Group?
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary me-3" type="button" (click)="deleteTaxGrouoPopUp.hide()">No</button>
        <button class="btn btn-primary" type="button" (click)="deleteTaxGroup()">Yes</button>
      </div>


    </div>
  </div>
</div>

<div class="modal fade" bsModal #taxOptionValidationPopUp="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-centered">
    <div class="modal-content">
      <div class="p-4">
        The Group of Tax Option {{getTaxOptionName()}} is already asigned for the facility {{getStoreName(facilityId)}}
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary me-3" type="button" (click)="taxOptionValidationPopUp.hide()">Ok</button>
      </div>


    </div>
  </div>
</div>





